module.exports = __webpack_public_path__ + "img/bg.93a89bff.jpg";